<template>
  <div
    class="flex flex-col justify-center items-center fixed z-50 inset-0 bg-opacity-25 bg-black"
    @click.self="close"
  >
    <div class="form-card relative">
      <button
        class="system-button absolute right-4 top-4"
        @click.prevent="close"
      >
        <close-icon class="w-8 fill-current" />
      </button>

      <div class="text-sm mt-6">
        <div>
          <p class="font-medium">Nombre</p>
          <p>{{ previousState.name }}</p>
        </div>

        <div>
          <p class="font-medium">Animal</p>
          <p>{{ previousState.breed.pet_type.name }}</p>
        </div>

        <div>
          <p class="font-medium">Raza</p>
          <p>{{ previousState.custom_breed || previousState.breed.name }}</p>
        </div>

        <div>
          <p class="font-medium">Sexo</p>
          <p>{{ previousState.gender }}</p>
        </div>

        <div>
          <p class="font-medium">Fecha de nacimiento</p>
          <p>{{ formatDate(previousState.birthdate) }}</p>
        </div>

        <div>
          <p class="font-medium">Peso</p>
          <p>{{ previousState.weight }}kg</p>
        </div>

        <div>
          <p class="font-medium">Composición corporal</p>
          <p>{{ previousState.pet_detail.body_composition.value }}</p>
        </div>

        <div>
          <p class="font-medium">Nivel de actividad</p>
          <p>{{ previousState.pet_detail.activity_level.value }}</p>
        </div>

        <div>
          <p class="font-medium">Actitud al comer</p>
          <p>{{ previousState.pet_detail.eating_attitude.value }}</p>
        </div>

        <div>
          <p class="font-medium">Comida actual</p>
          <p>{{ previousState.pet_detail.food_type.value }}</p>
        </div>

        <div>
          <p class="font-medium">Marca de comida actual</p>
          <p>{{ getValue(previousState.pet_detail.food_brand) }}</p>
        </div>

        <div>
          <p class="font-medium">Alergias alimentarias</p>
          <p
            v-if="
              getAttributes('food_allergy').length === 0 &&
              !previousState.pet_detail.other_food_allergy
            "
          >
            -
          </p>
          <p
            v-for="attribute in getAttributes('food_allergy')"
            :key="attribute.id"
          >
            - {{ attribute.value }}
          </p>
          <p v-if="previousState.pet_detail.other_food_allergy">
            - {{ previousState.pet_detail.other_food_allergy }}
          </p>
        </div>

        <div>
          <p class="font-medium">Examen de alérgenos</p>
          <p>{{ previousState.has_allergies_test ? "Sí" : "No" }}</p>
        </div>

        <div>
          <p class="font-medium">Problemas de salud</p>
          <p
            v-if="
              getAttributes('disease').length === 0 &&
              !previousState.pet_detail.other_disease
            "
          >
            -
          </p>
          <p v-for="attribute in getAttributes('disease')" :key="attribute.id">
            - {{ attribute.value }}
          </p>
          <p v-if="previousState.pet_detail.other_disease">
            - {{ previousState.pet_detail.other_disease }}
          </p>
        </div>

        <div>
          <p class="font-medium">Come premios, snacks o sobras</p>
          <p>{{ previousState.pet_detail.has_snacks ? "Sí" : "No" }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate, formatDatetime } from "@/utils/dateFormatter";
export default {
  name: "Pet History Modal",

  props: {
    previousState: Object,
  },

  methods: {
    formatDate,

    formatDatetime,

    close() {
      this.$emit("close");
    },

    getAttributes(type) {
      return this.previousState.pet_detail.pet_detail_attributes.filter(
        (att) => att.type === type
      );
    },

    getValue(field) {
      if (!field) {
        return "-";
      }

      return field;
    },
  },
};
</script>